import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Icon } from '@iconify/react';
import './MyJobs.css';

const MyJobs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('My Jobs');

  useEffect(() => {
    // Simulate data fetching
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const NaviconStyle = {
    marginRight: '10px',
    marginTop: '10px',
    marginLeft: '10px',
  };

  // Map tabs to iframe sources
  const tabSources = {
    Posts: 'https://wwww.spcommunity.org.za/jobs',
    'My Jobs': 'https://www.spcommunity.org.za/user-jobs-matched/',
    Inbox: 'https://www.spcommunity.org.za/user-message/',
    Profile: 'https://www.spcommunity.org.za/user-profile/',
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div className="jobs-container">
      {/* Top Nav Menu */}
      <div className="top-nav">
        {Object.keys(tabSources).map((tab) => (
          <button
            key={tab}
            className={`nav-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
        
      </div>
      {/* Iframe content */}
      <iframe
        src={tabSources[activeTab]}
        style={{ width: '100%', height: '100vh', border: 'none', overflow: 'auto' }}
        title={activeTab}
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </div>
  );
};

export default MyJobs;



















/*
const ContactForm = () => {
    return (
      <iframe
        src="https://jobs.spcommunity.org.za"
       style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
      ></iframe>
    );
  };
  
  export default ContactForm; */

  